import { useQuery } from "@tanstack/react-query";
import { EdgeDetail, graphService } from "../services/graphService";
import { queryKeys } from "./queries/keys";

interface UseEdgeDetailResult {
  edgeDetailResponse: EdgeDetail | null;
  loading: boolean;
  error: string | null;
}

/**
 * Custom hook for fetching relationship/edge details via TanStack Query.
 *
 * @param relationshipId - The ID of the relationship to fetch
 * @returns Object containing edge data, loading state, and error
 */
export const useEdgeDetail = (
  relationshipId: string | null,
): UseEdgeDetailResult => {
  const { data, isLoading, error } = useQuery({
    queryKey: queryKeys.entities.edge(relationshipId!),
    queryFn: () => graphService.getEdgeDetail(relationshipId!),
    enabled: !!relationshipId,
    staleTime: 2 * 60 * 1000,
  });

  return {
    edgeDetailResponse: data ?? null,
    loading: isLoading,
    error: error
      ? (error as Error).message || "Failed to load relationship details"
      : null,
  };
};
